import React, { useState, useEffect, useRef } from 'react';
import BreadcrumbLink from './BreadcrumbLink';
import BreadcrumbRoot from './BreadcrumbRoot';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const BreadcrumbTrailWrapper = styled.div`
  position: sticky;
  top: ${(props) => props.stickytop};
  font-size: 12px;
  padding: 10px 0 0;
  z-index: 1;
  background: #fff;

  @media only screen and (max-width: 576px) {
    transform: translateY(-10px);
  }
`;

const StyledSeparator = styled(FontAwesomeIcon)`
  color: #888;
  margin-right: 2px;
`;
const EmptyTrailWrapper = styled.div`
  opacity: 0;
  pointer-events: none;
`;

const BreadcrumbTrail = (props) => {
  const breadcrumbRef = useRef();
  const [breadcrumbTop, setBreadcrumbTop] = useState(0);

  useEffect(() => {
    setBreadcrumbTop(breadcrumbRef.current.getBoundingClientRect().top);
  }, [breadcrumbTop]);

  return (
    <BreadcrumbTrailWrapper
      stickytop={`${breadcrumbTop}px`}
      ref={breadcrumbRef}
    >
      {_getBreadcrumbNodes(props)}
    </BreadcrumbTrailWrapper>
  );
};

const _getBreadcrumbNodes = ({
  onRootClick,
  onRootDrop,
  onCrumbClick,
  onCrumbDrop,
  trail,
}) => {
  if (!trail)
    return (
      <EmptyTrailWrapper>
        <BreadcrumbRoot
          key={'breadcrumb-root-0'}
          onClick={onRootClick}
          onDrop={onRootDrop}
          separator={<Separator key="separator-root-0" />}
        />
      </EmptyTrailWrapper>
    );

  const delimiter = ',';

  const parts = trail.split(delimiter);

  const breadNodes = parts.map((part, i) => {
    const lastOne = i === parts.length - 1;
    let separatorNode = null;

    if (!lastOne) {
      separatorNode = <Separator key={`separator-part-${part}`} />;
    }

    const innerNode = (
      <span>
        {part} {separatorNode} &nbsp;
      </span>
    );

    if (lastOne)
      return <strong key={`inner-node-part-${part}`}>{innerNode}</strong>;

    const parentPath = parts.slice(0, i).join(delimiter);

    return (
      <React.Fragment key={`breadcrumb-fragment-${part}`}>
        <BreadcrumbLink
          key={`breadcrumb-part-${part}`}
          parentPath={parentPath}
          onClick={onCrumbClick}
          onDrop={onCrumbDrop}
          part={part}
        >
          {part}
        </BreadcrumbLink>
        &nbsp;
        {separatorNode}
        &nbsp;
      </React.Fragment>
    );
  });

  breadNodes.unshift(
    <BreadcrumbRoot
      key={'breadcrumb-root-0'}
      onClick={onRootClick}
      onDrop={onRootDrop}
      separator={<Separator key="separator-root-0" />}
    />,
  );

  return breadNodes;
};

const Separator = () => <StyledSeparator icon={faAngleRight} />;

BreadcrumbTrail.propTypes = {
  onRootClick: PropTypes.func.isRequired,
  onCrumbClick: PropTypes.func.isRequired,
  onRootDrop: PropTypes.func.isRequired,
  onCrumbDrop: PropTypes.func.isRequired,
  trail: PropTypes.string,
};

export default BreadcrumbTrail;
